import React from "react";
import Highcharts from "highcharts";
import { Paper,  CardContent } from "@mui/material";
import { useTheme } from "@mui/material/styles";
function DoctorsCharts( 
  {details}:{details :any}) {

  
  const theme = useTheme();
  let chartOptions = {
    chart: {
      plotBackgroundColor: "#fff",
      type: "column",
      backgroundColor: "#fff",
      options3d: {
        enabled: true,
        alpha: 0,
        beta: -1,
        depth: 29,
        viewDistance: 25,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Patient list (Doctor wise)",
      align: "left",
      style: {
        color: "#242424", 
      },
    },
    xAxis: {
      categories: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      crosshair: false,
      accessibility: {
        description: "Months",
      },
      labels: {
        style: {
          color: "#242424", // Set the text color for the xAxis labels
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Number of patients",
        style: {
          color: "#242424", // Set the text color for the yAxis labels
        },
      },
      labels: {
        style: {
          color: "#242424", // Set the text color for the yAxis labels
        },
      },
    },

    tooltip: {
      valueSuffix: " Patients",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        color: "#242424", // Set the text color for series names
      },
    },
    series: [],
  };
  const backgroundColor = theme.palette.mode === "light" ? true : false;
  const chartRef = React.useRef<HTMLDivElement | null>(null);
  React.useEffect(() => {
    const bgColor = {
      light:"#fff",
      dark:"#242424"
    }
    const textColor = {
      light:"#242424",
      dark:"#fff"
    }
    console.log(backgroundColor);
    if (backgroundColor) {
      chartOptions.chart.backgroundColor = bgColor.light
      chartOptions.chart.plotBackgroundColor = bgColor.light
      chartOptions.title.style.color = textColor.light
      chartOptions.xAxis.labels.style.color = textColor.light
      chartOptions.yAxis.title.style.color = textColor.light
      chartOptions.yAxis.labels.style.color = textColor.light
      chartOptions.legend.itemStyle.color = textColor.light
    }else{
      chartOptions.chart.backgroundColor = bgColor.dark
      chartOptions.chart.plotBackgroundColor = bgColor.dark
      chartOptions.title.style.color = textColor.dark
      chartOptions.xAxis.labels.style.color = textColor.dark
      chartOptions.yAxis.title.style.color = textColor.dark
      chartOptions.yAxis.labels.style.color = textColor.dark
      chartOptions.legend.itemStyle.color = textColor.dark
    }
  chartOptions.series = details?.length ? details : [{name:"",data:[0,0,0,0,0,0,0,0,0,0,0,0]}]
    Highcharts.chart(chartRef.current as any, chartOptions as any)
  }, [backgroundColor,details]);
  return (
    <Paper elevation={3}>
      <CardContent>
        <div ref={chartRef} />
      </CardContent>
    </Paper>
  );
}

export default DoctorsCharts;
